import { render, staticRenderFns } from "./BorrowerProfile.vue?vue&type=template&id=266376ca"
import script from "./BorrowerProfile.vue?vue&type=script&lang=js"
export * from "./BorrowerProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('266376ca')) {
      api.createRecord('266376ca', component.options)
    } else {
      api.reload('266376ca', component.options)
    }
    module.hot.accept("./BorrowerProfile.vue?vue&type=template&id=266376ca", function () {
      api.rerender('266376ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customers/view/BorrowerProfile.vue"
export default component.exports